
import React from 'react';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import { ManagementHeader } from '@/components/interview/ManagementHeader';
import { ManagementContent } from '@/components/interview/ManagementContent';
import { useInterviewManagement } from '@/hooks/interview/useInterviewManagement';

const InterviewManagementPage: React.FC = () => {
  const {
    pendingInterviews,
    isLoading,
    error,
    handlePublish,
    handleReject,
    handleManualRefresh
  } = useInterviewManagement();

  return (
    <EditorialLayout>
      <div className="max-w-6xl mx-auto py-4 px-4 space-y-6">
        <ManagementHeader onRefresh={handleManualRefresh} />
        
        <ManagementContent 
          isLoading={isLoading}
          error={error}
          pendingInterviews={pendingInterviews}
          onPublish={handlePublish}
          onReject={handleReject}
        />
      </div>
    </EditorialLayout>
  );
};

export default InterviewManagementPage;
